import { Flex, Form } from "antd";
import { PatientSearchTab } from "./SearchFlow/PatientSearchTab";
import { PaymentFooter } from "./PaymentRequest/PaymentFooter";
import { PaymentForm } from "./PaymentForm/PaymentForm";
import { type SelectedInsuranceCarrier, type SelectedPatient, useSearchFlowContext } from "./SearchFlow/useSearchFlow";
import { TransactorKind } from "@vyne-shared/components/Payment/transactorKind";
import { UnmergeButton } from "./PaymentRequest/UnmergeButton";
import type { PatientUpdateForm } from "api/requests";

export const NewPaymentModalContent = () => {
    const [paymentForm] = Form.useForm<PatientUpdateForm>();
    const { merging, modal, selectedTransactor } = useSearchFlowContext();

    if (merging) {
        throw new Error("NewPaymentModalContent should not be used in a merging state");
    }

    const existingPrp = getExistingPrp(selectedTransactor);

    return (
        <PatientSearchTab
            title="New Payment Request"
            footer={<PaymentFooter hostModal={modal} paymentForm={paymentForm} existingPrp={existingPrp} />}
        >
            <PaymentForm form={paymentForm} existingPrp={existingPrp} />
            <Flex align="center" justify="center">
                <UnmergeButton modal={modal} existingPrp={existingPrp} />
            </Flex>
        </PatientSearchTab>
    );
};

function getExistingPrp(selectedTransactor: SelectedPatient | SelectedInsuranceCarrier | undefined) {
    if (!selectedTransactor) {
        return undefined;
    }

    if (selectedTransactor.kind !== TransactorKind.Patient) {
        throw new Error("NewPaymentModalContent should not be used with a non-patient (insurance carrier) selected");
    }

    return selectedTransactor.transactor;
}
